import axios from 'axios';

import type {
  IUserRequestUserTransferBody,
  IUserRequestUserTransferResponse,
} from '@/app-package';

const requestUserTransfer = async (body: IUserRequestUserTransferBody) => {
  const { data } = await axios.post<IUserRequestUserTransferResponse>(
    'transfer/request_transfer',
    body,
  );

  return data;
};

export default requestUserTransfer;
